export default __webpack_public_path__ + "static/media/camera-shutter.4008e954.mp3";